import { create } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

export default {
  namespaced: true,

  actions: {
    async chargeOverages(_commit, { month, year }) {
      try {
        const response = await create({ url: `/api/admin/overage`, data: { month: month, year: year } })
        return response.status
      } catch (error) {
        throw new FormErrors(error)
      }
    }
  }
}
